<script>
import authService from "@/services/auth";
import logo from "@/mixins/logo";
import SubNav from "./SubNav.vue";
import SupportForm from "@/components/profile/SupportForm.vue";
import { mapGetters } from "vuex";
import { isAppointmentsEnabled, theme } from "@/services/config";
import api from "@/services/api";
import userService from "@/services/user";
import indicationsDraftService from "@/services/indications-draft";

const USERNAME_LENGTH = 23;

export default {
  name: "TopNav",
  mixins: [logo],

  components: {
    SubNav,
    SupportForm,
  },

  data() {
    return {
      nav: "",
      defaultNav: "dashboard",
      showProfileMenu: false,
      isSupportModalOpen: false,
      isAppointmentsEnabled,
      isPaymentEnabled: theme === "dash",
      boxes: [],
      selectedBox: this.$store.state.user.doctor?.selectedBox || null,
    };
  },

  computed: {
    ...mapGetters(["isAdmin", "isAssistant", "isDoctor", "isPatient", "role"]),

    userName() {
      const name = this.$store.state.user.firstName;
      const lastName = this.$store.state.user.lastName;
      const username = `${name} ${lastName}`;

      return username.length > USERNAME_LENGTH
        ? `${username.slice(0, USERNAME_LENGTH)}...`
        : username;
    },

    isProfileSection() {
      return this.$route.name === "profile";
    },
  },

  watch: {
    "$route.path": {
      handler: function (path) {
        this.nav = path.split("/")[1] || "dashboard";
      },
      immediate: true,
    },
  },

  methods: {
    signOut() {
      // Solo en el cierre de sesión explícito: si la sesión vence (401) el
      // borrador se conserva para recuperarlo al volver a entrar.
      indicationsDraftService.removeUserDrafts(this.$store.state.user?._id);
      authService.clearToken();
      this.$router.push({ name: "login" });
    },
    showSupportModal() {
      this.hideProfile();
      this.isSupportModalOpen = true;
    },
    showSettings() {
      this.hideProfile();
      this.$router.push({ name: "settings" });
    },
    showUsers() {
      this.hideProfile();
      this.$router.push({ name: "users-list" });
    },
    showPayments() {
      this.hideProfile();
      this.$router.push({ name: "payments-list" });
    },
    closeSupportModal() {
      this.isSupportModalOpen = false;
    },
    profile() {
      this.$router.push({ name: "profile" });
      this.hideProfile();
    },
    hideProfile() {
      this.showProfileMenu = false;
    },
    isActive(section) {
      if (section) {
        return this.$route.name === section;
      }
      return (
        this.$route.name === "profile" ||
        this.$route.name === "settings" ||
        this.$route.name === "users-list"
      );
    },
    async setBox(boxId) {
      try {
        await userService.updateSelectedBox(this.$store.state.user._id, boxId);

        this.selectedBox = boxId;

        const updatedUser = {
          ...this.$store.state.user,
          doctor: {
            ...this.$store.state.user.doctor,
            selectedBox: boxId,
          },
        };
        this.$store.commit("setUser", updatedUser);
      } catch (err) {
        console.error("Error setting selected box", err);
      }
    },
  },
  created() {
    if (this.isDoctor) {
      const userId = this.$store.state.user._id;

      api
        .get(`/boxes/user/${userId}`)
        .then(({ data }) => {
          this.boxes = data;
        })
        .catch((err) => {
          console.error("❌ Error fetching boxes by doctor", err);
        });
    }
  },
};
</script>

<template lang="pug">
header.header
  .topnav
    router-link.topnav__logo(:to="{ name: 'home' }")
      img(v-if="logoAltUrl || logoUrl" :src="logoAltUrl || logoUrl" :alt="`Logo ${theme}`")
      micon(v-else :name="'quantux-logo-horizontal-nuevo'")

    .topnav__right
      // select de boxes
      el-select.box-selector(
        v-if="isDoctor"
        v-model="selectedBox"
        placeholder="Seleccioná box"
        size="small"
        @change="setBox"
      )
        el-option(
          label="Sin box"
          :value="null"   
        )
        el-option(
          v-for="box in boxes"
          :key="box._id"
          :label="box.name"
          :value="box._id"
        )
    nav.user-dropdown(:class="{active: showProfileMenu, 'is-route-active': isActive()}", v-click-outside="hideProfile")
      a.user-dropdown__trigger(@click="showProfileMenu = !showProfileMenu", href="#")
        micon.user-dropdown__profile-icon(name="settings")
      a.user-dropdown__item(href="#" @click="profile" :class="{active: showProfileMenu, 'is-route-active': isActive('profile')}")
        strong Perfil
      a.user-dropdown__item(v-if="isPaymentEnabled && isAdmin" @click="showPayments" :class="{active: showProfileMenu, 'is-route-active': isActive('payments-list')}")
        strong Pagos
      a.user-dropdown__item(href="#" @click="showSupportModal" :class="{active: showProfileMenu}")
        strong Soporte
      a.user-dropdown__item(href="#" @click="signOut" :class="{active: showProfileMenu}")
        strong Cerrar sesión
  sub-nav(:nav="nav")
  support-form(:dialogFormVisible="isSupportModalOpen" @close="closeSupportModal")
</template>
